module.exports = __webpack_public_path__ + "static/Download_on_the_App_Store_Badge_US-UK_RGB_blk_092917-546f7fe6b7d296ef4ccc2ccda03387da.svg";